
import { Sidebar } from '../components/Sidebar';

export const UnauthorizedPage: React.FC = () => {
  // Não é mais necessário mainPage, pois não há botão de navegação
  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f7f8fa' }}>
      <Sidebar />
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          padding: '48px 32px',
          minWidth: 320,
          textAlign: 'center',
        }}>
          <h1 style={{ fontSize: 32, fontWeight: 700, color: '#d32f2f', marginBottom: 16 }}>⛔ Acesso Negado</h1>
          <p style={{ fontSize: 18, color: '#555' }}>Você não tem permissão para acessar esta página.</p>
        </div>
      </main>
    </div>
  );
};
